import e from"styled-components";const i=e.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	border-radius: ${({borderRadius:e})=>`${e}px`};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	background-color: ${({theme:e})=>e.bg.card};
	padding: 16px;
	height: 100%;
	box-sizing: border-box;
	justify-content: space-between;
`,t=e.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`,o=e.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,l=e.h1`
	font-size: 22px;
	margin: 0;
	font-weight: 600;
	color: ${({theme:e})=>e.text.input};
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,r=e.p`
	font-size: 14px;
	margin: 0;
	font-weight: 400;
	color: #868686;
	line-height: 18px;
	outline: none;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,n=e.div`
	position: relative;
	font-size: 30.5px;
	cursor: pointer;
`,d=e.div`
	display: flex;
	align-items: center;
	justify-content: ${({hasLink:e})=>e?"space-between":"flex-end"};
`,c=e.span`
	font-size: 14px;
	font-weight: 400;
	width: 80%;
	color: ${({color:e})=>e};
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,p=e.div`
	display: grid;
	place-content: center;
	background-color: ${({color:e})=>e};
	border-radius: 9999px;
	width: 24px;
	height: 24px;
`,a=e.div`
	display: grid;
	place-content: center;
	width: fit-content;

	svg {
		fill: ${({color:e})=>e};

		path {
			fill: ${({color:e})=>e};
		}
		circle {
			fill: ${({color:e})=>e};
		}
		rect {
			fill: ${({color:e})=>e};
		}
	}
`;export{p as CardArrowContainer,t as CardBody,i as CardContainer,o as CardContentContainer,n as CardEmoji,d as CardFooter,l as CardHeading,a as CardIconContainer,c as CardLink,r as CardParagraph};
